export const doOpacityClicks = () => {
    let opacitymods = document.querySelectorAll('.image-opacity-module');
    for(let opacitymod of opacitymods){
      let images = opacitymod.querySelectorAll('.imgwrap');
			let contentblocks = opacitymod.querySelectorAll('.content .opacitycol');
      for(let img of images) img.addEventListener('click', (e) => {opacityClick(e)} );
      for(let img of images) img.addEventListener('mouseover', (e) => {opacityClick(e)} );
			for(let contentblock of contentblocks) contentblock.addEventListener('mouseover', (e) => {opacityClick(e)} );
    }
  }
export const opacityClick = (e) => {
		let activeIndex = 0;
		let contentActivated;
    let col = e.target.closest('.column');
    let cols = col.parentElement?.children;
    let content = col.parentElement?.nextSibling?.children;

		if (!content) {
			contentActivated = true;
			cols = col.parentElement?.children;
			content = col.parentElement.previousSibling.children;
			activeIndex = Array.from(e.target.closest('.layout').querySelectorAll('.content .column')).indexOf(col);
		}

    for (let idx = 0; idx < cols.length; idx++) {
			if (contentActivated) {
				Array.from(cols).forEach(element => {
					element.classList.remove('active');
				});

				Array.from(content).forEach(element => {
					element.classList.remove('active');
				})

				cols[activeIndex].classList.add('active');
				content[activeIndex].classList.add('active');
			} else {
				let thiscol = cols[idx];
				if (col === thiscol) {
					thiscol.classList.add('active');
					content[idx].classList.add('active');
				} else {
					thiscol.classList.remove('active');
					content[idx].classList.remove('active');
				}
			}
    }
}
